import { receiveItemLimit, receiveQtyPerItemLimit } from '../restrictions';
import { receiveDisplayHelpFlag, updateIsSimpleReturns } from '../page';

export const RECEIVE_RETURNS_SETTINGS = 'RECEIVE_RETURNS_SETTINGS';

export const receiveReturnsSettings = (returnsSettings) => (dispatch, getState) => {
  const { page: { productType } = {} } = getState();
  const {
    [productType]: {
      itemLimit,
      qtyPerItemLimit,
      display_help: displayHelp = false,
      validation: { returnType = 'full_returns' } = {},
    } = {},
  } = returnsSettings;

  if (itemLimit) dispatch(receiveItemLimit(itemLimit));
  if (qtyPerItemLimit) dispatch(receiveQtyPerItemLimit(qtyPerItemLimit));
  dispatch(updateIsSimpleReturns(returnType === 'simple_returns'));
  dispatch(receiveDisplayHelpFlag(displayHelp));

  dispatch({
    type: RECEIVE_RETURNS_SETTINGS,
    data: { returnsSettings },
  });
};
